import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FormattedMessage, useIntl } from "react-intl";
import { copyToClipboard } from "../../Utilities/clipboardHelper";

export default function CopyUrlDialog({ isOpen, title, url, note, onClose }) {
  const intl = useIntl();

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      modalClassName="actmail-width-modal"
      className="actmail-width-modal"
    >
      <ModalHeader toggle={onClose}>{title}</ModalHeader>
      <ModalBody>
        <div
          style={{
            whiteSpace: "normal",
            overflowWrap: "break-word",
            wordBreak: "break-all",
            maxHeight: "60vh",
            overflowY: "auto",
            fontFamily: "monospace",
          }}
        >
          {url}
        </div>
        {note && <p className="mt-3 mb-0 text-muted">{note}</p>}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => copyToClipboard(url, intl)}>
          <FontAwesomeIcon icon={faCopy} className="me-2" />{" "}
          <FormattedMessage id="Copy" />
        </Button>
        <Button color="primary" onClick={onClose}>
          OK
        </Button>
      </ModalFooter>
    </Modal>
  );
}
